module.exports = __webpack_public_path__ + "img/avatar-exercise-03.c71f2113.png";